import {
    REGISTER_URL,
    UPLOAD_KTP_URL,
    UPLOAD_PRICELIST_URL,
    REGISTERED_SUPPLIER_ID_URL,
    CREATE_SAMPLE_URL,
    UPLOAD_DOCUMENT_URL,
    SAMPLE_ID_URL
} from '../constants/api';
import axios from 'axios';

export function register({data}) {
    return axios.post(REGISTER_URL, data);
}

export function uploadKtp({data}) {
    return axios.post(UPLOAD_KTP_URL, data);
}

export function uploadPricelist({data}) {
    return axios.post(UPLOAD_PRICELIST_URL, data);
}

export function getByRegistrationCode({registrationCode}) {
    return axios.get(REGISTERED_SUPPLIER_ID_URL(registrationCode));
}

export function createSample({supplierOnboardId, data}) {
    return axios.post(CREATE_SAMPLE_URL({ supplierOnboardId: supplierOnboardId }), data);
}

export function uploadDocument({supplierOnboardId, data}) {
    return axios.post(UPLOAD_DOCUMENT_URL({ supplierOnboardId: supplierOnboardId }), data);
}

export function getSampleById({sampleId}) {
    return axios.get(SAMPLE_ID_URL(sampleId));
}